/**
 * 生成基础axios对象，并对请求和响应做处理
 * 前后端约定接口返回解构规范
 * {
 *    code:0,
 *    data:"成功",
 *    message:""
 * }
 */
import axios from 'axios'
import router from '@/router'
import { Toast } from 'vant'
import {serialize} from '@/utils/util'
import {LogOut, isLogin, getToken} from '@/utils/auth'
import website from '@/config/website'
import {Base64} from 'js-base64'

// import store___del from '@/store___del/'
// 创建一个独立的axios实例
const passUrl = ['/blade-auth/oauth/token']
const service = axios.create({
  // 设置baseUr地址,如果通过proxy跨域可直接填写base地址
  baseURL: '/api',
  // 定义统一的请求头部
  headers: {
    post: {
      // 'Content-Type': ''
    }
  },
  // 配置请求超时时间
  timeout: 30000,
  // 如果用的JSONP，可以配置此参数带上cookie凭证，如果是代理和CORS不用设置
  withCredentials: false
})
// 请求拦截
service.interceptors.request.use(config => {
  // 自定义header，可添加项目token
  if (isLogin()) {
    config.headers['Blade-Auth'] = getToken()
  }
  config.headers['Authorization'] = `Basic ${Base64.encode(`${website.clientId}:${website.clientSecret}`)}`
  config.headers['Tenant-Id'] = '000000'
  if (config.text === true) {
    config.headers['Content-Type'] = 'text/plain'
  }
  if (config.method === 'post') {
    // config.data = serialize(config.data)
    config.headers['Content-Type'] = 'application/json'
  } else {
    config.data = { unused: 0 }
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  }
  if (passUrl.indexOf(config.url) !== -1) {
    if (config.method === 'post') {
      config.data = serialize(config.data)
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    }
  }
  return config
}, error => {
  return Promise.reject(error)
})
// 返回拦截
service.interceptors.response.use(res => {
  // 获取状态码

  const status = res.data.code || res.status
  // const statusWhiteList = website.statusWhiteList || []
  const message = res.data.msg || res.data.error_description || '未知错误'
  // 如果在白名单里则自行catch逻辑处理
  // if (statusWhiteList.includes(status)) return Promise.reject(res)
  // 如果是401则跳转到登录页面
  if (status === 401) {
    LogOut()
    router.push({path: '/login'})
  }
  // 如果请求为非200否者默认统一处理
  if (status !== 200) {
    Toast(message)
    return Promise.reject(new Error(message))
  }
  return res
}, error => {
  const status = error && error.response && (error.response.status || error.response.data.code)
  if (status && status === 401) {
    LogOut()
    router.push({path: '/login'})
  }
  let loginError = error.response.data.error_description
  if (loginError !== null && loginError === 'Incorrect username or password') {
    // loginError = 'Nombre de usuario o contraseña incorrectos'
    // loginError = 'Incorrect username or password' //英语
    // loginError = 'Nama pengguna atau kata sandi salah' //印尼语
    loginError = 'Nombre de usuario o contraseña incorrectos' // 西班牙语
  }
  return Promise.reject(new Error(error && error.response && (error.response.data.msg || loginError)))
})
export default service



// WEBPACK FOOTER //
// ./src/axios/interceptor.js